<template>
  <el-table-column align="center" label="侵权歌单信息">
    <el-table-column label="歌单ID" width="100" prop="tracklistId"></el-table-column>
    <el-table-column label="侵权歌单&视频信息" width="310" v-slot="{ row }" show-overflow-tooltip>
      <track-info-mod :data="row"></track-info-mod>
    </el-table-column>
    <el-table-column label="被侵权歌曲&视频信息" width="310" v-slot="{ row }" show-overflow-tooltip>
      <track-info-mod :data="row.originInfo"></track-info-mod>
    </el-table-column>
    <!--原曲授权方ID、原曲原始版权方ID、版权开始时间、版权结束时间、词比例、曲比例、是否同步至高危曲库[是|否]-->
    <el-table-column label="原曲授权方ID" width="100" prop="originTrackCpCompanyId"></el-table-column>
    <el-table-column label="原曲原始版权方ID" width="120" prop="originTrackOriginCpCompanyId"></el-table-column>
    <el-table-column label="版权开始时间" width="100" prop="copyrightFrom"></el-table-column>
    <el-table-column label="版权结束时间" width="100" prop="copyrightTo"></el-table-column>
    <el-table-column label="词比例" width="60" prop="wordPercent"></el-table-column>
    <el-table-column label="曲比例" width="60" prop="musicPercent"></el-table-column>
    <el-table-column label="是否同步至高危曲库" width="130" v-slot="{ row }">
      {{ row.syncToRisk ? '是' : '否' }}
    </el-table-column>
    <el-table-column label="权利文件" width="90" v-slot="{ row }" show-overflow-tooltip>
      <a v-if="row.rightFile" :href="$toPreview(row.rightFile.fileUrl)" target="_blank">{{ row.rightFile.fileName }}</a>
      <template v-else>-</template>
    </el-table-column>
  </el-table-column>
</template>

<script>
import TrackInfoMod from './TrackInfoMod.vue'

export default {
  name: 'ComplaintInfoCol',
  components: {
    TrackInfoMod
  },
  data() {
    return {
      syncToRisk: 0
    }
  }
}
</script>
